import React, { MouseEventHandler } from "react";
import SearchFilterString from "../../model/SearchFilterString";
import FormInputText from "../common/FormInputText";

interface ISearchFilterMinMaxProps {
  nameMin: string;
  nameMax: string;
  onChange: (
    inputID: string,
    newValue: string | boolean | Set<number> | Set<string>
  ) => void;
  labelMin: string;
  valueMin: string | undefined;
  labelMax: string;
  valueMax: string | undefined;
}

/* Process filters based on string values */
function SearchFilterMinMax({
  nameMin,
  nameMax,
  onChange,
  labelMin,
  valueMin,
  labelMax,
  valueMax,
}: ISearchFilterMinMaxProps) {
  return (
    <div className="checkbox-filter">
      <div className="grid grid-cols-2 gap-4">
        <FormInputText
          id={nameMin}
          label={labelMin}
          value={valueMin}
          onChange={onChange}
        />
        <FormInputText
          id={nameMax}
          label={labelMax}
          value={valueMax}
          onChange={onChange}
        />
      </div>
    </div>
  );
}

export default SearchFilterMinMax;
